export const host = process.env.REACT_APP_API_HOST;
// https://github.com/Moonshotedx/hajari_fe/blob/main/src/configure.js
// export const host = "http://localhost:3020";
// export const host='http://123.0.0.181:3020'
